/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorDayData', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorDayData'), require('../model/CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorDayDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorDayData, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, PerformanceIndicatorDataFilter, PerformanceIndicatorDayData, CorporateStructureLink) {
  'use strict';

  /**
   * PerformanceIndicatorDayData service.
   * @module api/PerformanceIndicatorDayDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorDayDataApi. 
   * @alias module:api/PerformanceIndicatorDayDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorDayDataClearPut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataClearPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clear
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataClearPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataClearPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataClearPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataClearPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeAllPut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDayData>} body 
     * @param {Boolean} rollOverLevels 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.aggregationLevelID 
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceIndicatorDayDataMergeAllPut = function(_4SAPIAppID, body, rollOverLevels, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeAllPut";
      }

      // verify the required parameter 'rollOverLevels' is set
      if (rollOverLevels == undefined || rollOverLevels == null) {
        throw "Missing the required parameter 'rollOverLevels' when calling performanceIndicatorDayDataMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rollOverLevels': rollOverLevels,
        'aggregationLevelID': opts['aggregationLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeTargetActualValuePut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetActualValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetActualValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} day 
     * @param {Integer} indicatorID 
     * @param {Number} value 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetActualValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataMergeTargetActualValuePut = function(_4SAPIAppID, body, year, month, day, indicatorID, value, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'day' is set
      if (day == undefined || day == null) {
        throw "Missing the required parameter 'day' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'value' is set
      if (value == undefined || value == null) {
        throw "Missing the required parameter 'value' when calling performanceIndicatorDayDataMergeTargetActualValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'day': day,
        'indicatorID': indicatorID,
        'value': value,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeTargetActualValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeTargetBudgetValuePut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetBudgetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetBudgetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} day 
     * @param {Integer} indicatorID 
     * @param {Number} value 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetBudgetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataMergeTargetBudgetValuePut = function(_4SAPIAppID, body, year, month, day, indicatorID, value, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'day' is set
      if (day == undefined || day == null) {
        throw "Missing the required parameter 'day' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'value' is set
      if (value == undefined || value == null) {
        throw "Missing the required parameter 'value' when calling performanceIndicatorDayDataMergeTargetBudgetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'day': day,
        'indicatorID': indicatorID,
        'value': value,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeTargetBudgetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeTargetForecastValuePut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetForecastValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetForecastValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} day 
     * @param {Integer} indicatorID 
     * @param {Number} value 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetForecastValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataMergeTargetForecastValuePut = function(_4SAPIAppID, body, year, month, day, indicatorID, value, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'day' is set
      if (day == undefined || day == null) {
        throw "Missing the required parameter 'day' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'value' is set
      if (value == undefined || value == null) {
        throw "Missing the required parameter 'value' when calling performanceIndicatorDayDataMergeTargetForecastValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'day': day,
        'indicatorID': indicatorID,
        'value': value,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeTargetForecastValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeTargetGoalValuePut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetGoalValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetGoalValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} day 
     * @param {Integer} indicatorID 
     * @param {Number} value 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetGoalValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataMergeTargetGoalValuePut = function(_4SAPIAppID, body, year, month, day, indicatorID, value, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'day' is set
      if (day == undefined || day == null) {
        throw "Missing the required parameter 'day' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'value' is set
      if (value == undefined || value == null) {
        throw "Missing the required parameter 'value' when calling performanceIndicatorDayDataMergeTargetGoalValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'day': day,
        'indicatorID': indicatorID,
        'value': value,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeTargetGoalValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataMergeTargetValuePut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} day 
     * @param {Integer} indicatorID 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.actual 
     * @param {Number} opts.goal 
     * @param {Number} opts.budget 
     * @param {Number} opts.forecast 
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataMergeTargetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorDayDataMergeTargetValuePut = function(_4SAPIAppID, body, year, month, day, indicatorID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }

      // verify the required parameter 'day' is set
      if (day == undefined || day == null) {
        throw "Missing the required parameter 'day' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorDayDataMergeTargetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'day': day,
        'indicatorID': indicatorID,
        'actual': opts['actual'],
        'goal': opts['goal'],
        'budget': opts['budget'],
        'forecast': opts['forecast'],
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/mergeTargetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorDayDataSearchPut operation.
     * @callback module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDayData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDayData>} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/PerformanceIndicatorDayDataApi~performanceIndicatorDayDataSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDayData>}
     */
    this.performanceIndicatorDayDataSearchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorDayDataSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorDayDataSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDayData];

      return this.apiClient.callApi(
        '/PerformanceIndicatorDayData/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
